export const testimonials = [
  {
    name: "林小满",
    role: "通勤族 · 关注 2 年",
    text: "每天地铁上刷一眼热榜就够了，不用在好几个平台之间来回切换。最难得的是它会写清楚事情的来龙去脉，不会只给一个标题就让人猜。",
  },
  {
    name: "阿哲",
    role: "内容爱好者 · 关注 1 年",
    text: "喜欢它的编辑精选，很多话题别人都在追流量，它反而在认真讲为什么这件事值得讨论。看完经常会有不一样的视角。",
  },
  {
    name: "周周",
    role: "学生党 · 关注半年",
    text: "分类做得特别清楚，我只想看影视综艺那一块，点进去就全是相关的内容，不会被其他八卦干扰，找东西很省时间。",
  },
  {
    name: "老陈",
    role: "自由职业 · 关注 3 年",
    text: "看到不实的说法，它会在正文里提醒以官方为准，这点很加分。吃瓜归吃瓜，分寸感拿捏得很好。",
  },
];